/* Modulo: Coverflow — frameless 3D coverflow.
   JS owns the active index; CSS owns the depth (zero CLS, SSR-symmetric fan).
   Click a side slide to center it, drag, arrow-keys, optional arrows + dots,
   loop wrap, lazy image hydration, aria-live announced, reduced-motion aware,
   idempotent init, theme-editor reload safe. Vanilla IIFE, no deps. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var SWIPE = 46;

  function initCoverflow(root) {
    if (root.dataset.moduloCvfReady === '1') return;
    root.dataset.moduloCvfReady = '1';

    var stage = root.querySelector('[data-stage]');
    var nodes = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var total = nodes.length;
    if (!stage || total < 2) return;

    var loop = root.dataset.loop === '1';
    var eachSide = parseInt(root.dataset.eachSide, 10) || 2;
    var dotsHost = root.querySelector('[data-dots]');
    var liveRegion = root.querySelector('[data-live]');
    var prevBtns = root.querySelectorAll('[data-prev]');
    var nextBtns = root.querySelectorAll('[data-next]');

    var active = 0;
    var dots = [];

    function hydrate(el) {
      var img = el.querySelector('img[data-src]');
      if (!img) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    function shortest(i) {
      var raw = i - active;
      if (loop) {
        if (raw > total / 2) raw -= total;
        if (raw < -total / 2) raw += total;
      }
      return raw;
    }

    function render() {
      for (var i = 0; i < total; i++) {
        var el = nodes[i];
        var off = shortest(i);
        var ao = off < 0 ? -off : off;
        el.style.setProperty('--off', off);
        el.style.setProperty('--sign', off === 0 ? 0 : (off > 0 ? 1 : -1));
        el.dataset.tier = ao < 3 ? ao : 3;
        el.dataset.hidden = ao > eachSide ? '1' : '0';
        el.style.zIndex = 100 - ao;
        var isCenter = off === 0;
        el.classList.toggle('is-center', isCenter);
        el.setAttribute('aria-hidden', isCenter ? 'false' : 'true');
        el.toggleAttribute('inert', !isCenter);
        if (ao <= eachSide) hydrate(el);
      }
      for (var d = 0; d < dots.length; d++) {
        if (d === active) dots[d].setAttribute('aria-current', 'true');
        else dots[d].removeAttribute('aria-current');
      }
      announce();
    }

    function announce() {
      if (!liveRegion) return;
      var title = nodes[active].getAttribute('data-title') || '';
      liveRegion.textContent = 'Slide ' + (active + 1) + ' of ' + total + (title ? ': ' + title : '');
    }

    function goTo(i) {
      var target = loop ? ((i % total) + total) % total : Math.max(0, Math.min(total - 1, i));
      if (target === active) return;
      active = target;
      render();
    }
    function next() { goTo(active + 1); }
    function prev() { goTo(active - 1); }

    // click a side slide to bring it to center
    nodes.forEach(function (el, i) {
      el.addEventListener('click', function (e) {
        if (el.classList.contains('is-center')) return;
        if (e.target.closest('a, button')) e.preventDefault();
        goTo(i);
      });
    });

    // dots
    if (dotsHost) {
      while (dotsHost.firstChild) dotsHost.removeChild(dotsHost.firstChild);
      for (var i = 0; i < total; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'modulo-cvf__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1) + ' of ' + total);
        if (i === active) b.setAttribute('aria-current', 'true');
        (function (idx) { b.addEventListener('click', function () { goTo(idx); }); })(i);
        dotsHost.appendChild(b);
        dots.push(b);
      }
    }

    function bind(list, fn) {
      for (var i = 0; i < list.length; i++) {
        list[i].addEventListener('click', function (e) { e.preventDefault(); fn(); });
      }
    }
    bind(prevBtns, prev);
    bind(nextBtns, next);

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
    });

    // pointer drag / swipe
    var sx = 0, drag = false;
    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('a, button')) return;
      if (e.button !== undefined && e.button !== 0) return;
      drag = true; sx = e.clientX;
    });
    function endDrag(e) {
      if (!drag) return;
      drag = false;
      var dx = (e && e.clientX != null ? e.clientX : sx) - sx;
      if (Math.abs(dx) > SWIPE) { dx < 0 ? next() : prev(); }
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', function () { drag = false; });
    stage.addEventListener('pointerleave', function (e) { if (drag) endDrag(e); });

    root._cvfDestroy = function () { root.dataset.moduloCvfReady = ''; };

    render();
  }

  function initAll(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-cvf]');
    for (var i = 0; i < els.length; i++) initCoverflow(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-modulo-cvf]') : null;
    if (el) initCoverflow(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-modulo-cvf]') : null;
    if (el && typeof el._cvfDestroy === 'function') el._cvfDestroy();
  });
})();
